import { dropdownTriggerClassname } from "app/components/Dropdown";
import { StatusIcon } from "app/components/Icons";
import CustomTooltip from "app/components/Tooltip";
import CommonStatusSelection from "app/containers/Features/components/CommonStatusSelection";
import {
  getStatusById
} from "app/containers/Features/containers/Boards/helpers";
import { selectTicketStatus } from "app/redux/selector";
import { ITicketStatus } from "app/types";
import clsx from "clsx";
import React, { useMemo } from "react";
import { useSelector } from "react-redux";

interface CustomProps {
  status: string;
  setValue: (val: string) => void;
  onOpen: () => void;
  onClose: () => void;
}

const SelectStatus: React.FC<CustomProps> = ({
  status,
  setValue,
  onOpen,
  onClose,
}) => {
  const statusData = useSelector(selectTicketStatus);

  const handleSelect = (data: ITicketStatus) => {
    setValue(data._id);
  };

  const selectedStatus = useMemo(() => {
    return getStatusById(statusData, status);
  }, [statusData, status]);

  return (
    <CommonStatusSelection
      trigger={
        <button
          className={clsx(
            "flex items-center justify-between w-full p-[6px] rounded-md ",
            dropdownTriggerClassname,
          )}
        >
          <CustomTooltip
            text="Click to choose status"
            className="flex items-center gap-1 "
            position="left"
          >
            {selectedStatus ? (
              <div className="flex  gap-2">
                <StatusIcon size={16} color={selectedStatus.color} />
                <span
                  className={`text-[${selectedStatus.color}] text-xs font-normal`}
                >
                  {selectedStatus.name}
                </span>
              </div>
            ) : (
              <span className="text-xs leading-[18px] font-normal text-secondary ">
                Choose status
              </span>
            )}
          </CustomTooltip>
        </button>
      }
      align="center"
      setValue={handleSelect}
      value={status}
      isHeader="Status"
      onOpen={onOpen}
      onClose={onClose}
    />
  );
};

export default SelectStatus;
